import { useState, useEffect, useRef } from "react";
import axiosService from "../../utils/axios.service";
import $ from "jquery";
import { notifications } from "../constant/Notify";
import { Spin } from "antd";
import { io } from "socket.io-client";
import _ from 'lodash';
import Select from "react-select";
import { customStylesOption } from "../constant/GeneralData";

const CAMERA_WIDTH = 1024;
const CAMERA_HEIGHT = 768;

let optionScreen = [
  { value: 1, label: 'Màn hình 1' },
  { value: 2, label: 'Màn hình 2' },
]

export function ViewImgCustomer2(props) {
  const [camDisplay, setCamDisplay] = useState(false);
  const [shot, setShot] = useState(false);
  const [imageShot, setImageShot] = useState(null);
  const [loading, setLoading] = useState(false);
  const [base64Image, setBase64Image] = useState(null);
  const [error, setError] = useState(null);
  const [ipadConnected, setIpadConnected] = useState(false);
  const [socketConnected, setSocketConnected] = useState(false);
  const [connectionState, setConnectionState] = useState("disconnected");
  const [screen, setScreen] = useState(localStorage.getItem("screen_qr") ?? 1);

  const socketRef = useRef(null);
  const videoRef = useRef(null);
  const peerRef = useRef(null);
  const pendingIceCandidatesRef = useRef([]);

  const iceServers = [{urls: "stun:stun.l.google.com:19302"}];
  const storeId = localStorage.getItem("currentStore")

  const createPeerConnection = () => {
    if (peerRef.current) {
      try {
        peerRef.current.close();
      } catch (e) {
        console.log("Close old peer error:", e);
      }

      peerRef.current = null;
    }

    const peer = new RTCPeerConnection({iceServers});

    peer.ontrack = (event) => {
      const remoteStream = event.streams?.[0];

      if (videoRef.current && remoteStream) {
        videoRef.current.srcObject = remoteStream;

        videoRef.current.play()
          .catch((err) => {
            console.log("Video play error:", err);
          });
      }
    };

    peer.onicecandidate = (event) => {
      if (!event.candidate) {
        return;
      }

      const socket = socketRef.current;

      if (!socket || !socket.connected) {
        console.warn("WE socket is not connected. Cannot send ICE.");
        return;
      }

      socket.emit("webrtc:ice:we", {
        storeId: storeId,
        screen: screen,
        candidate: event.candidate,
      });
    };

    peer.onconnectionstatechange = () => {
      setConnectionState(peer.connectionState);

      if (peer.connectionState === "connected") {
        setIpadConnected(true);
      }

      if (peer.connectionState === "disconnected" || peer.connectionState === "failed" || peer.connectionState === "closed") {
        setIpadConnected(false);
      }
    };

    peerRef.current = peer;

    return peer;
  };

  const handleOffer = async (data) => {
    try {
      if (!data?.offer) {
        console.warn("WebRTC offer is empty");
        return;
      }

      const socket = socketRef.current;
      if (!socket || !socket.connected) {
        console.warn("WE socket is not connected.");
        return;
      }

      const peer = peerRef.current || createPeerConnection();

      // Set remote description
      await peer.setRemoteDescription(new RTCSessionDescription(data.offer));

      // Add ICE candidates đang chờ
      if (pendingIceCandidatesRef.current.length > 0) {
        for (const candidate of pendingIceCandidatesRef.current) {
          try {
            await peer.addIceCandidate(new RTCIceCandidate(candidate));
          } catch (e) {
            console.log("Add pending ICE error:", e);
          }
        }
        pendingIceCandidatesRef.current = [];
      }

      // Create answer
      const answer = await peer.createAnswer();
      await peer.setLocalDescription(answer);

      socket.emit("webrtc:answer", { storeId: storeId, screen: screen, answer });
    } catch (e) {
      console.log("Handle WebRTC offer error:", e);
      notifications({type: "error", mess: "Không thể kết nối camera iPad"});
    }
  };

  const handleIceCandidate = async (data) => {
    const candidate = data?.candidate;

    if (!candidate) return;

    const peer = peerRef.current;
    if (!peer || !peer.remoteDescription) {
      pendingIceCandidatesRef.current.push(candidate);

      return;
    }

    try {
      await peer.addIceCandidate(new RTCIceCandidate(candidate));
    } catch (e) {console.log("Add ICE candidate error:", e);
    }
  };

  const handleCameraEvent = (data) => {
    if (!data?.action) return;
    

    switch (data.action) {
      case "closed":
        setIpadConnected(false);
        setConnectionState("disconnected");
        break;

      case "captured":
        break;

      case "uploaded":
        if (data.imageUrl) {
          setLoading(false);
          props.changeCurrenAvatar(data.imageUrl);
          notifications({type: "success", mess: "Cập nhật ảnh thành công"});
          closePopup();
        } else {
          setLoading(false);

          notifications({type: "error", mess: "Không nhận được URL ảnh"});
        }

        break;

      default:
        break;
    }
  };

  useEffect(() => {
    const socket = io(process.env.REACT_APP_API_SOCKET,
      {
        transports: ["websocket"],
        autoConnect: false,
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
      }
    );

    socketRef.current = socket;

    const handleConnect = () => {
      setSocketConnected(true);
      socket.emit("device:register", {
        type: "we",
        storeId: storeId,
        screen: screen,
      });
    };

    const handleDisconnect = (reason) => {
      setSocketConnected(false);
      setIpadConnected(false);
      setConnectionState("disconnected");
    };

    const handleConnectError = (err) => {
      setSocketConnected(false);
    };

    socket.on("connect", handleConnect);
    socket.on("disconnect", handleDisconnect);
    socket.on("connect_error", handleConnectError);
    socket.on("webrtc:offer", handleOffer);
    socket.on("webrtc:ice", handleIceCandidate);
    socket.on("camera", handleCameraEvent);
    socket.connect();

    return () => {
      socket.off("connect", handleConnect);
      socket.off("disconnect", handleDisconnect);
      socket.off("connect_error", handleConnectError);
      socket.off("webrtc:offer", handleOffer);
      socket.off("webrtc:ice", handleIceCandidate);
      socket.off("camera", handleCameraEvent);

      if (peerRef.current) {
        try {
          peerRef.current.close();
        } catch (e) {
          console.log("Close peer error:", e);
        }
        peerRef.current = null;
      }

      pendingIceCandidatesRef.current = [];

      if (videoRef.current) {
        try {
          videoRef.current.pause();
        } catch (e) {}
        videoRef.current.srcObject = null;
      }

      socket.disconnect();
      socketRef.current = null;
      setSocketConnected(false);
      setIpadConnected(false);
    };
  }, [screen]);

  useEffect(() => {
    return () => {
      if (peerRef.current) {
        try {
          peerRef.current.close();
        } catch (e) {}

        peerRef.current = null;
      }

      if (videoRef.current) videoRef.current.srcObject = null;

      pendingIceCandidatesRef.current = [];
    };
  }, []);

  const openCam = async () => {
    if (!props.customer?.full_name) {
      notifications({type: "error", mess: "Vui lòng cập nhật tên khách hàng trước"});

      return;
    }

    const socket = socketRef.current;
    if (!socket || !socket.connected) {
      notifications({type: "error", mess: "Không kết nối được với iPad",});
      return;
    }

    try {
      setCamDisplay(true);
      setImageShot(null);
      setShot(false);
      setError(null);
      setIpadConnected(false);
      setConnectionState("connecting");
      pendingIceCandidatesRef.current = [];
      createPeerConnection();
      socket.emit("camera", {
        action: "open",
        storeId: storeId,
        screen: screen,
        customerId: props.customer?.id,
      });
    } catch (e) {
      notifications({type: "error", mess: "Không thể mở camera iPad"});
    }
  };

  const capturePreviewOnWE = () => {
    const video = videoRef.current;

    if (!video || !video.videoWidth || !video.videoHeight) {
      notifications({type: "error", mess: "Camera chưa sẵn sàng, vui lòng thử lại"});
      return false;
    }

    const canvas = document.createElement("canvas");
    canvas.width = CAMERA_WIDTH;
    canvas.height = CAMERA_HEIGHT;
    const ctx = canvas.getContext("2d");

    if (!ctx) return false;

    const targetRatio = CAMERA_WIDTH / CAMERA_HEIGHT;
    const videoRatio = video.videoWidth / video.videoHeight;
    let sx = 0;
    let sy = 0;
    let sWidth = video.videoWidth;
    let sHeight = video.videoHeight;
    if (videoRatio > targetRatio) {
      sWidth = video.videoHeight * targetRatio;
      sx = (video.videoWidth - sWidth) / 2;
    } else {
      sHeight = video.videoWidth / targetRatio;
      sy = (video.videoHeight - sHeight) / 2;
    }

    ctx.save();
    ctx.translate(CAMERA_WIDTH, 0);
    ctx.scale(-1, 1);
    ctx.drawImage(video, sx, sy, sWidth, sHeight, 0, 0, CAMERA_WIDTH, CAMERA_HEIGHT);
    ctx.restore();

    const previewImage = canvas.toDataURL("image/jpeg", 1);

    setImageShot(previewImage);
    setShot(true);
    return true;
  };

  const takePhoto = () => {
    if (loading) return;
    const socket = socketRef.current;
    if (!socket || !socket.connected) {
      notifications({type: "error", mess: "Socket chưa kết nối"});
      return;
    }
    if (!ipadConnected) {
      notifications({type: "error", mess: "Camera iPad chưa kết nối"});
      return;
    }

    const previewSuccess = capturePreviewOnWE();

    if (!previewSuccess) return;

    socket.emit("camera", {
      action: "capture",
      storeId: storeId,
      screen: screen,
      customerId: props.customer?.id,
      width: CAMERA_WIDTH,
      height: CAMERA_HEIGHT,
    });
  };

  const uploadCameraPhoto = () => {
    if (loading) return;
    const socket = socketRef.current;
    if (!socket || !socket.connected) {
      notifications({type: "error", mess: "Socket chưa kết nối"});
      return;
    }
    if (!ipadConnected) {
      notifications({type: "error", mess: "Camera iPad chưa kết nối"});
      return;
    }

    setLoading(true);
    socket.emit("camera", {
      action: "upload",
      storeId: storeId,
      screen: screen,
      customerId: props.customer?.id,
    });
  };

  const resumePhoto = async () => {
    if (loading) return;

    setImageShot(null);
    setShot(false);
    setError(null);
    setIpadConnected(false);
    setConnectionState("connecting");

    const socket = socketRef.current;

    if (!socket || !socket.connected) {
      notifications({type: "error", mess: "Socket chưa kết nối"});
      return;
    }

    pendingIceCandidatesRef.current = [];
    createPeerConnection();
    socket.emit("camera", {
      action: "open",
      storeId: storeId,
      screen: screen,
      customerId: props.customer?.id,
    });
  };

  const closePhoto = () => {
    if (loading) return;

    const socket = socketRef.current;

    if (socket && socket.connected) {
      socket.emit("camera", {
        action: "close",
        storeId: storeId,
        screen: screen,
      });
    }

    if (peerRef.current) {
      try {
        peerRef.current.close();
      } catch (e) {
        console.log("Close peer error:", e);
      }
      peerRef.current = null;
    }

    pendingIceCandidatesRef.current = [];
    if (videoRef.current) {
      try {
        videoRef.current.pause();
      } catch (e) {}

      videoRef.current.srcObject = null;
    }

    setIpadConnected(false);
    setConnectionState("disconnected");
    setShot(false);
    setCamDisplay(false);
    setImageShot(null);
    setError(null);
  };

  const closePopup = () => {
    if (loading) return;
    closePhoto();
    props.close();
  };

  const uploadPhoto = async (type) => {
    if (loading) return;

    const photo = type === 1 ? imageShot : base64Image;

    if (!photo) {
      notifications({type: "error", mess: "Chưa có ảnh để tải lên"});
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const payload = {
        placeID: 17956,
        photo,
      };

      let res = null;

      if (props.customer && props.customer.avatar_url?.length > 10) {
        res = await axiosService(`api/hanet-ai/update-customer/${props.customer.id}`, "POST", payload);
      } else {
        res = await axiosService(`api/hanet-ai/add-customer/${props.customer.id}`, "POST", payload);
      }

      if (res?.data?.success) {
        if (res?.data?.data?.returnCode === 1) {
          const avatar = res?.data?.data?.data?.path ?? res?.data?.data?.data?.file;
          setLoading(false);
          closePopup();
          props.changeCurrenAvatar(avatar);
          notifications({type: "success", mess: "Cập nhật thành công"});

          return;
        }

        setLoading(false);
        setError(res?.data?.data);
        notifications({type: "error", mess: res?.data?.data?.returnMessage ?? "Đã có lỗi"});

        return;
      }

      setLoading(false);

      const message = res?.data?.data?.returnMessage ?? "Đã có lỗi";
      notifications({type: "error", mess: message});
    } catch (e) {
      console.log("Upload avatar error:", e);
      setLoading(false);
      notifications({type: "error", mess: "Không thể cập nhật ảnh"});
    }
  };

  const uploadImageFromLocal = () => {
    if (loading) return false;
  
    setBase64Image(null);
    setError(null);
    closePhoto();
    $(".customer-avatar-input").trigger("click");
  };

  const onFileChange = (e) => {
    e.preventDefault();

    const file = e.target.files?.[0];

    if (!file) return;

    setError(null);
    const reader = new FileReader();

    reader.onloadend = () => {
      const img = new Image();

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const targetW = CAMERA_WIDTH;
        const targetH = CAMERA_HEIGHT;
        canvas.width = targetW;
        canvas.height = targetH;
        ctx.fillStyle = "#000";
        ctx.fillRect(0, 0, targetW, targetH);
        const { width: iw, height: ih } = img;
        const ratio = Math.min(targetW / iw, targetH / ih);
        const newW = iw * ratio;
        const newH = ih * ratio;
        const x = (targetW - newW) / 2;
        const y = (targetH - newH) / 2;

        ctx.drawImage(img, x, y, newW, newH);

        const resized = canvas.toDataURL("image/jpeg", 1);

        setBase64Image(resized);
      };

      img.src = reader.result;
    };

    reader.readAsDataURL(file);

    e.target.value = "";
  };

  const getDefaultScreen = (option, screen) => {
    let keyChoose = _.findIndex(option, (o) => o.value == screen);
    return option[keyChoose];
  }

  const onChangeScreen = (e) => {
    localStorage.setItem("screen_qr", e.value)
    setScreen(e.value)
  }

  return (
    <div className="popup-cent">
      <div className="content-popup fadeInDown" style={{ width: `${CAMERA_WIDTH}px` }}>
        <div className="head-popup">
          <div className="title">Ảnh khách hàng</div>
          <div className="close" onClick={closePopup}>×</div>
        </div>
        <div className="body-popup">
          <div className="row">
            <div className="col-12">
              <Spin spinning={loading}>
                <div className="customer-avatar" style={{textAlign: "center"}}>
                  {/* ẢNH LOCAL */}
                  {base64Image ? (
                    <div className="upload-local">
                      <img
                        src={base64Image}
                        style={{
                          width: `${CAMERA_WIDTH}px`,
                          height: `${CAMERA_HEIGHT}px`,
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                        alt="Preview"
                      />
                      <div className="cameraControls">
                        <div onClick={() => setBase64Image(null)} id="close">
                          <i className="fas fa-times" />
                        </div>

                        <div onClick={() => uploadPhoto(2)} id="upload">
                          <i className="fas fa-upload" />
                        </div>

                        <div onClick={ uploadImageFromLocal} id="resume">
                          <i className="fas fa-redo" />
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {/* AVATAR HIỆN TẠI */}
                  {!camDisplay && !base64Image && props.customer?.avatar_url ? (
                    <a href={props.customer.avatar_url} target="_blank" rel="noreferrer">
                      <img src={props.customer.avatar_url}
                        style={{
                          width: `${CAMERA_WIDTH}px`,
                          height: `${CAMERA_HEIGHT}px`,
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                        alt="Customer"
                      />
                    </a>
                  ) : null}

                  {/* CAMERA IPAD */}
                  {camDisplay ? (
                    <div className="camera"
                      style={{
                        width: `${CAMERA_WIDTH}px`,
                        maxWidth: "100%",
                        margin: "0 auto",
                      }}
                    >
                      {/* LIVE VIDEO / PREVIEW IMAGE */}
                      {!shot ? (
                        <video id="webcam" ref={videoRef} autoPlay playsInline muted
                          style={{
                            width: `${CAMERA_WIDTH}px`,
                            height: `${CAMERA_HEIGHT}px`,
                            maxWidth: "100%",
                            display: "block",
                            objectFit: "cover",
                            transform: "scaleX(-1)",
                          }}
                        />
                      ) : (
                        <img src={imageShot} alt="Captured"
                          style={{
                            width: `${CAMERA_WIDTH}px`,
                            height: `${CAMERA_HEIGHT}px`,
                            maxWidth: "100%",
                            objectFit: "contain",
                            display: "block",
                          }}
                        />
                      )}

                      {/* TRẠNG THÁI IPAD */}

                      {!shot ? (
                        <div style={{ marginTop: "10px", fontSize: "14px" }}>
                          {ipadConnected ? (
                            <span style={{color: "green"}}>● Camera iPad đang kết nối</span>
                          ) : (
                            <span style={{color: "#999"}}> Đang kết nối camera iPad...</span>
                          )}
                        </div>
                      ) : null}

                      {/* CAMERA CONTROLS */}

                      {!shot ? (
                        <div className="cameraControls">
                          <div onClick={closePhoto} id="close">
                            <i className="fas fa-times" />
                          </div>

                          <div onClick={takePhoto} id="take-photo">
                            <i className="fas fa-camera" />
                          </div>
                        </div>
                      ) : (
                        <div className="cameraControls">
                          <div onClick={closePhoto} id="close">
                            <i className="fas fa-times" />
                          </div>

                          <div onClick={uploadCameraPhoto} id="upload">
                            <i className="fas fa-upload" />
                          </div>

                          <div onClick={resumePhoto} id="resume">
                            <i className="fas fa-redo" />
                          </div>
                        </div>
                      )}
                    </div>
                  ) : null}

                  <input className="customer-avatar-input"
                    type="file" accept=".jpeg,.jpg,.png"
                    hidden onChange={onFileChange}
                  />

                  {error ? (
                    <div style={{textAlign: "center", color: "red", fontSize: "18px", marginTop: "20px"}}>
                      {error.returnMessage ? (<p>{error.returnMessage}</p>) : null}
                    </div>
                  ) : null}
                </div>
              </Spin>
            </div>
          </div>
        </div>

        <div className="bottom-popup">
          <div className="row">
            <div className="col-4">
              <div className="button-container" style={{float: "left"}}>
                <div className="button-cent style3" onClick={closePopup}>
                  <span><i className="fas fa-times" /></span> Đóng
                </div>
              </div>
            </div>

            <div className="col-8">
              <div className="button-container">
                <div className="select-option-store" style={{display: "inline-block", width: '120px', position: 'relative', top: '2px'}}>
                  <Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
                    isSearchable={false}
                    className="select"
                    value={getDefaultScreen(optionScreen, screen)}
                    options={optionScreen}
                    onChange={onChangeScreen}
                    styles={customStylesOption}
                    isDisabled={camDisplay}
                  />
                </div>
                {/* Upload ảnh từ máy */}
                {/* {!camDisplay ?
                  <div className="button-cent style2" onClick={uploadImageFromLocal}>
                    <span><i className="fas fa-upload" /></span> Tải ảnh lên
                  </div>
                :null} */}

                {/* Camera */}
                {camDisplay ? (
                  <div className="button-cent style" onClick={closePhoto}>
                    <span><i className="fas fa-camera" /></span>Đóng Camera
                  </div>
                ) : (
                  <div className="button-cent style" onClick={openCam}>
                    <span><i className="fas fa-camera" /></span> Mở camera
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="overlay" onClick={closePopup} />
    </div>
  );
}